import Swiper, { Navigation, Pagination } from 'swiper/core';

Swiper.use([Navigation, Pagination]);

class ExternalWidgetDeTijd {
  constructor() {
    this.dom = {
      swiper: document.getElementById('propertySwiperDeTijd'),
    };

    this.components = {
      swiperInstance: null,
    };

    this.data = {
      swiperConfig: {
        speed: 350,
        spaceBetween: 16,
        loop: true,
        allowTouchMove: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
        breakpointsInverse: true,
        breakpoints: {
          576: {
            allowTouchMove: false,
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      },
    };

    this.mount();
  }

  mount() {
    this.components.swiperInstance = new Swiper(this.dom.swiper, this.data.swiperConfig);
  }
}

if (document.getElementById('external-property-widget-detijd')) {
  // eslint-disable-next-line no-new
  new ExternalWidgetDeTijd();
}
